







































import { inject } from 'inversify-props';
import { Component, Vue } from "vue-property-decorator";
import CenterSelector from "@/components/CenterSelector.vue";
import SideMenu from "@/components/SideMenu.vue";
import { auth, patient as patientStore, doctor as doctorStore, center as centerStore } from "@/store/modules";
import { CenterModel } from '../models/center';
import DependencyIdentifiers from '@/ioc/DependencyIdentifiers';
import { IAuthService } from '@/interfaces/Services';

interface MenuSettings {
  isEnabled: boolean;
  isMinified: boolean;
  isTemporary: boolean;
}

@Component({
  components: {
    SideMenu,
    CenterSelector
  }
})
class DashboardLayout extends Vue {
  @inject(DependencyIdentifiers.AuthService)
  private authService!: IAuthService;

  private componentKey = 0;
  private parmaStoreKey = 'hemo_sidebar_large_minified';
  private isPermanentMenuMinified: boolean = true;
  private isTemporaryMenuEnabled: boolean = false;

  beforeMount() {
    const stored = this.$cookies.get(this.parmaStoreKey);
    if (stored) {
      this.isPermanentMenuMinified = stored == '1';
    }
  }

  async onCenterChange() {
    patientStore.flushAll();
    doctorStore.flushAll();
    await this.authService.cacheMetadata();
    this.componentKey++;
  }

  get menuSettings(): MenuSettings {
    // Temporary (mobile) menu settings
    if (this.$vuetify.breakpoint.mdAndDown) {
      return {
        isTemporary: true,
        isMinified: false,
        isEnabled: this.isTemporaryMenuEnabled
      }
    }

    return {
      isTemporary: false,
      isMinified: this.isPermanentMenuMinified,
      isEnabled: true,
    };
  }

  get isCenterChangeAllowed() {
    return auth.hasPrimaryCenter && auth.isManager && !auth.hasExportLock;
  }

  get currentCenter() {
    return centerStore.items[auth.currentCenterId!];
  }

  permanentMenuToggle() {
    this.isPermanentMenuMinified = !this.isPermanentMenuMinified;
    this.updateCookieStore();
  }

  temporaryMenuToggle() {
    this.isTemporaryMenuEnabled = !this.isTemporaryMenuEnabled;
  }

  private updateCookieStore() {
    this.$cookies.set(this.parmaStoreKey, this.isPermanentMenuMinified ? '1' : '0');
  }
}

export default DashboardLayout;
